/* eslint-disable dot-notation */
import React from 'react';
import PropTypes from 'prop-types';
import {
  gtagInit,
  gtagVisit,
  yaInit,
  yaVisit
} from 'mt-react-common/utils/Analytics';

gtagInit();
yaInit();

export default WrappedComponent => {
  const VisitorAnalytics = props => {
    gtagVisit(props.location.pathname);
    yaVisit(props.location.pathname);
    return <WrappedComponent {...props} />;
  };

  VisitorAnalytics.propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired
    }).isRequired
  };

  return VisitorAnalytics;
};



// WEBPACK FOOTER //
// ./src/components/Hocs/VisitorAnalytics/VisitorAnalytics.js